export default "__VITE_ASSET__Bes_nyyc__"